export default {
  'en-US': {
    getHelp: 'Get Help',
    routing: {
      Dashboard: 'Dashboard',
      ImportOrder: 'Import Orders',
      ExportOrders: 'Export Orders',
      CopyOrders: 'Copy Orders',
      OrdersWithView: 'Orders',
      Confirmation: 'Confirmation',
      ConfirmMove: 'ConfirmMove',
      SignUp: 'Sign Up',
      Login: 'Login',
      ForgotPassword: 'Forgot Password',
      SendPassword: 'Send Password',
      Qualify: 'Qualify',
      Customers: 'Customers',
      ShowCustomer: 'Customer',
      CreateCustomer: 'Create Customer',
      ShowProduct: 'Product',
      ProductDetails: 'ProductDetails'
    }
  },
  'ja-JP': {
    getHelp: '助けを得ます',
    routing: {
      Dashboard: 'ダッシュボード',
      ImportOrder: 'オーダーのインポート',
      OrdersWithView: '注文',
      Confirmation: '確認',
      ConfirmMove: '移動の確認',
      SignUp: 'サインアップ',
      Login: 'ログイン',
      ForgotPassword: 'パスワードをお忘れですか',
      SendPassword: 'パスワードを送信',
      Qualify: '資格'
    }
  }
}
